export const data = [
  { countryCode: 'US', value: '1', label: 'USA' },
  { countryCode: 'GB', value: '44', label: 'UK' },
  { countryCode: 'AF', value: '93', label: 'Afghanistan' },
  { countryCode: 'AX', value: '358', label: 'Aland Islands' },
  { countryCode: 'AL', value: '355', label: 'Albania' },
  { countryCode: 'DZ', value: '213', label: 'Algeria' },
  { countryCode: 'AS', value: '1', label: 'American Samoa' },
  { countryCode: 'AD', value: '376', label: 'Andorra' },
  { countryCode: 'AO', value: '244', label: 'Angola' },
  { countryCode: 'AI', value: '1', label: 'Anguilla' },
  { countryCode: 'AQ', value: '672', label: 'Antarctica' },
  { countryCode: 'AG', value: '1', label: 'Antigua and Barbuda' },
  { countryCode: 'AR', value: '54', label: 'Argentina' },
  { countryCode: 'AM', value: '374', label: 'Armenia' },
  { countryCode: 'AW', value: '297', label: 'Aruba' },
  { countryCode: 'AU', value: '61', label: 'Australia' },
  { countryCode: 'AT', value: '43', label: 'Austria' },
  { countryCode: 'AZ', value: '994', label: 'Azerbaijan' },
  { countryCode: 'BS', value: '1', label: 'Bahamas' },
  { countryCode: 'BH', value: '973', label: 'Bahrain' },
  { countryCode: 'BD', value: '880', label: 'Bangladesh' },
  { countryCode: 'BB', value: '1', label: 'Barbados' },
  { countryCode: 'BY', value: '375', label: 'Belarus' },
  { countryCode: 'BE', value: '32', label: 'Belgium' },
  { countryCode: 'BZ', value: '501', label: 'Belize' },
  { countryCode: 'BJ', value: '229', label: 'Benin' },
  { countryCode: 'BM', value: '1', label: 'Bermuda' },
  { countryCode: 'BT', value: '975', label: 'Bhutan' },
  { countryCode: 'BO', value: '591', label: 'Bolivia' },
  {
    countryCode: 'BQ',
    value: '599',
    label: 'Bonaire, Saint Eustatius and Saba ',
  },
  { countryCode: 'BA', value: '387', label: 'Bosnia Herzegovina' },
  { countryCode: 'BW', value: '267', label: 'Botswana' },
  { countryCode: 'BV', value: '55', label: 'Bouvet Island' },
  { countryCode: 'BR', value: '55', label: 'Brazil' },
  { countryCode: 'IO', value: '246', label: 'British Indian Ocean Territory' },
  { countryCode: 'BN', value: '673', label: 'Brunei' },
  { countryCode: 'BG', value: '359', label: 'Bulgaria' },
  { countryCode: 'BF', value: '226', label: 'Burkina Faso' },
  { countryCode: 'BI', value: '257', label: 'Burundi' },
  { countryCode: 'KH', value: '855', label: 'Cambodia' },
  { countryCode: 'CM', value: '237', label: 'Cameroon' },
  { countryCode: 'CA', value: '1', label: 'Canada' },
  { countryCode: 'CV', value: '238', label: 'Cape Verde Islands' },
  { countryCode: 'KY', value: '1', label: 'Cayman Islands' },
  { countryCode: 'CF', value: '236', label: 'Central African Republic' },
  { countryCode: 'TD', value: '235', label: 'Chad' },
  { countryCode: 'CL', value: '56', label: 'Chile' },
  { countryCode: 'CN', value: '86', label: 'China' },
  { countryCode: 'CX', value: '61', label: 'Christmas Island' },
  { countryCode: 'CC', value: '61', label: 'Cocos Islands' },
  { countryCode: 'CO', value: '57', label: 'Colombia' },
  { countryCode: 'KM', value: '269', label: 'Comoros' },
  { countryCode: 'CG', value: '242', label: 'Congo' },
  { countryCode: 'CK', value: '682', label: 'Cook Islands' },
  { countryCode: 'CR', value: '506', label: 'Costa Rica' },
  { countryCode: 'HR', value: '385', label: 'Croatia' },
  { countryCode: 'CU', value: '53', label: 'Cuba' },
  { countryCode: 'CW', value: '599', label: 'Curacao' },
  { countryCode: 'CY', value: '90', label: 'Cyprus - North' },
  { countryCode: 'CY', value: '357', label: 'Cyprus - South' },
  { countryCode: 'CZ', value: '420', label: 'Czech Republic' },
  {
    countryCode: 'CD',
    value: '243',
    label: 'Democratic Republic of the Congo',
  },
  { countryCode: 'DK', value: '45', label: 'Denmark' },
  { countryCode: 'DJ', value: '253', label: 'Djibouti' },
  { countryCode: 'DM', value: '1', label: 'Dominica' },
  { countryCode: 'DO', value: '1', label: 'Dominican Republic' },
  { countryCode: 'TL', value: '670', label: 'East Timor' },
  { countryCode: 'EC', value: '593', label: 'Ecuador' },
  { countryCode: 'EG', value: '20', label: 'Egypt' },
  { countryCode: 'SV', value: '503', label: 'El Salvador' },
  { countryCode: 'GQ', value: '240', label: 'Equatorial Guinea' },
  { countryCode: 'ER', value: '291', label: 'Eritrea' },
  { countryCode: 'EE', value: '372', label: 'Estonia' },
  { countryCode: 'ET', value: '251', label: 'Ethiopia' },
  { countryCode: 'FK', value: '500', label: 'Falkland Islands' },
  { countryCode: 'FO', value: '298', label: 'Faroe Islands' },
  { countryCode: 'FJ', value: '679', label: 'Fiji' },
  { countryCode: 'FI', value: '358', label: 'Finland' },
  { countryCode: 'FR', value: '33', label: 'France' },
  { countryCode: 'GF', value: '594', label: 'French Guiana' },
  { countryCode: 'PF', value: '689', label: 'French Polynesia' },
  { countryCode: 'TF', value: '262', label: 'French Southern Territories' },
  { countryCode: 'GA', value: '241', label: 'Gabon' },
  { countryCode: 'GM', value: '220', label: 'Gambia' },
  { countryCode: 'GE', value: '995', label: 'Georgia' },
  {
    countryCode: 'GS',
    value: '500',
    label: 'South Georgia and the South Sandwich Islands',
  },
  { countryCode: 'DE', value: '49', label: 'Germany' },
  { countryCode: 'GH', value: '233', label: 'Ghana' },
  { countryCode: 'GI', value: '350', label: 'Gibraltar' },
  { countryCode: 'GR', value: '30', label: 'Greece' },
  { countryCode: 'GL', value: '299', label: 'Greenland' },
  { countryCode: 'GD', value: '1', label: 'Grenada' },
  { countryCode: 'GP', value: '590', label: 'Guadeloupe' },
  { countryCode: 'GU', value: '671', label: 'Guam' },
  { countryCode: 'GT', value: '502', label: 'Guatemala' },
  { countryCode: 'GG', value: '44', label: 'Guernsey' },
  { countryCode: 'GN', value: '224', label: 'Guinea' },
  { countryCode: 'GW', value: '245', label: 'Guinea - Bissau' },
  { countryCode: 'GY', value: '592', label: 'Guyana' },
  { countryCode: 'HT', value: '509', label: 'Haiti' },
  {
    countryCode: 'HM',
    value: '672',
    label: 'Heard Island and McDonald Islands',
  },
  { countryCode: 'HN', value: '504', label: 'Honduras' },
  { countryCode: 'HK', value: '852', label: 'Hong Kong' },
  { countryCode: 'HU', value: '36', label: 'Hungary' },
  { countryCode: 'IS', value: '354', label: 'Iceland' },
  { countryCode: 'IN', value: '91', label: 'India' },
  { countryCode: 'ID', value: '62', label: 'Indonesia' },
  { countryCode: 'IR', value: '98', label: 'Iran' },
  { countryCode: 'IQ', value: '964', label: 'Iraq' },
  { countryCode: 'IE', value: '353', label: 'Ireland' },
  { countryCode: 'IM', value: '44', label: 'Isle of Man' },
  { countryCode: 'IL', value: '972', label: 'Israel' },
  { countryCode: 'IT', value: '39', label: 'Italy' },
  { countryCode: 'CI', value: '225', label: 'Ivory Coast' },
  { countryCode: 'JM', value: '1', label: 'Jamaica' },
  { countryCode: 'JP', value: '81', label: 'Japan' },
  { countryCode: 'JE', value: '44', label: 'Jersey' },
  { countryCode: 'JO', value: '962', label: 'Jordan' },
  { countryCode: 'KZ', value: '7', label: 'Kazakhstan' },
  { countryCode: 'KE', value: '254', label: 'Kenya' },
  { countryCode: 'KI', value: '686', label: 'Kiribati' },
  { countryCode: 'KR', value: '82', label: 'Korea - South' },
  { countryCode: 'KW', value: '965', label: 'Kuwait' },
  { countryCode: 'KG', value: '996', label: 'Kyrgyzstan' },
  { countryCode: 'LA', value: '856', label: 'Laos' },
  { countryCode: 'LV', value: '371', label: 'Latvia' },
  { countryCode: 'LB', value: '961', label: 'Lebanon' },
  { countryCode: 'LS', value: '266', label: 'Lesotho' },
  { countryCode: 'LR', value: '231', label: 'Liberia' },
  { countryCode: 'LY', value: '218', label: 'Libya' },
  { countryCode: 'LI', value: '417', label: 'Liechtenstein' },
  { countryCode: 'LT', value: '370', label: 'Lithuania' },
  { countryCode: 'LU', value: '352', label: 'Luxembourg' },
  { countryCode: 'MO', value: '853', label: 'Macao' },
  { countryCode: 'MK', value: '389', label: 'Macedonia' },
  { countryCode: 'MG', value: '261', label: 'Madagascar' },
  { countryCode: 'MW', value: '265', label: 'Malawi' },
  { countryCode: 'MY', value: '60', label: 'Malaysia' },
  { countryCode: 'MV', value: '960', label: 'Maldives' },
  { countryCode: 'ML', value: '223', label: 'Mali' },
  { countryCode: 'MT', value: '356', label: 'Malta' },
  { countryCode: 'MH', value: '692', label: 'Marshall Islands' },
  { countryCode: 'MQ', value: '596', label: 'Martinique' },
  { countryCode: 'MR', value: '222', label: 'Mauritania' },
  { countryCode: 'MU', value: '230', label: 'Mauritius' },
  { countryCode: 'YT', value: '269', label: 'Mayotte' },
  { countryCode: 'MX', value: '52', label: 'Mexico' },
  { countryCode: 'FM', value: '691', label: 'Micronesia' },
  { countryCode: 'MD', value: '373', label: 'Moldova' },
  { countryCode: 'MC', value: '377', label: 'Monaco' },
  { countryCode: 'MN', value: '976', label: 'Mongolia' },
  { countryCode: 'ME', value: '382', label: 'Montenegro' },
  { countryCode: 'MS', value: '1', label: 'Montserrat' },
  { countryCode: 'MA', value: '212', label: 'Morocco' },
  { countryCode: 'MZ', value: '258', label: 'Mozambique' },
  { countryCode: 'MM', value: '95', label: 'Myanmar' },
  { countryCode: 'NA', value: '264', label: 'Namibia' },
  { countryCode: 'NR', value: '674', label: 'Nauru' },
  { countryCode: 'NP', value: '977', label: 'Nepal' },
  { countryCode: 'NL', value: '31', label: 'Netherlands' },
  { countryCode: 'NC', value: '687', label: 'New Caledonia' },
  { countryCode: 'NZ', value: '64', label: 'New Zealand' },
  { countryCode: 'NI', value: '505', label: 'Nicaragua' },
  { countryCode: 'NE', value: '227', label: 'Niger' },
  { countryCode: 'NG', value: '234', label: 'Nigeria' },
  { countryCode: 'NU', value: '683', label: 'Niue' },
  { countryCode: 'NF', value: '672', label: 'Norfolk Islands' },
  { countryCode: 'KP', value: '850', label: 'North Korea' },
  { countryCode: 'MP', value: '670', label: 'Northern Marianas' },
  { countryCode: 'NO', value: '47', label: 'Norway' },
  { countryCode: 'OM', value: '968', label: 'Oman' },
  { countryCode: 'PK', value: '92', label: 'Pakistan' },
  { countryCode: 'PW', value: '680', label: 'Palau' },
  { countryCode: 'PS', value: '970', label: 'Palestinian Territory' },
  { countryCode: 'PA', value: '507', label: 'Panama' },
  { countryCode: 'PG', value: '675', label: 'Papua New Guinea' },
  { countryCode: 'PY', value: '595', label: 'Paraguay' },
  { countryCode: 'PE', value: '51', label: 'Peru' },
  { countryCode: 'PH', value: '63', label: 'Philippines' },
  { countryCode: 'PN', value: '870', label: 'Pitcairn' },
  { countryCode: 'PL', value: '48', label: 'Poland' },
  { countryCode: 'PT', value: '351', label: 'Portugal' },
  { countryCode: 'PR', value: '1', label: 'Puerto Rico' },
  { countryCode: 'QA', value: '974', label: 'Qatar' },
  { countryCode: 'RE', value: '262', label: 'Reunion' },
  { countryCode: 'RO', value: '40', label: 'Romania' },
  { countryCode: 'RU', value: '7', label: 'Russia' },
  { countryCode: 'RW', value: '250', label: 'Rwanda' },
  { countryCode: 'BL', value: '590', label: 'Saint Barthelemy' },
  { countryCode: 'MF', value: '590', label: 'Saint Martin' },
  { countryCode: 'PM', value: '508', label: 'Saint Pierre and Miquelon' },
  { countryCode: 'VC', value: '1', label: 'Saint Vincent and the Grenadines' },
  { countryCode: 'WS', value: '685', label: 'Samoa' },
  { countryCode: 'SM', value: '378', label: 'San Marino' },
  { countryCode: 'ST', value: '239', label: 'Sao Tome and Principe' },
  { countryCode: 'SA', value: '966', label: 'Saudi Arabia' },
  { countryCode: 'SN', value: '221', label: 'Senegal' },
  { countryCode: 'RS', value: '381', label: 'Serbia' },
  { countryCode: 'SC', value: '248', label: 'Seychelles' },
  { countryCode: 'SL', value: '232', label: 'Sierra Leone' },
  { countryCode: 'SG', value: '65', label: 'Singapore' },
  { countryCode: 'SX', value: '599', label: 'Sint Maarten' },
  { countryCode: 'SK', value: '421', label: 'Slovak Republic' },
  { countryCode: 'SI', value: '386', label: 'Slovenia' },
  { countryCode: 'SB', value: '677', label: 'Solomon Islands' },
  { countryCode: 'SO', value: '252', label: 'Somalia' },
  { countryCode: 'ZA', value: '27', label: 'South Africa' },
  { countryCode: 'SS', value: '211', label: 'South Sudan' },
  { countryCode: 'ES', value: '34', label: 'Spain' },
  { countryCode: 'LK', value: '94', label: 'Sri Lanka' },
  { countryCode: 'SH', value: '290', label: 'St. Helena' },
  { countryCode: 'KN', value: '1', label: 'St. Kitts' },
  { countryCode: 'LC', value: '1', label: 'St. Lucia' },
  { countryCode: 'SD', value: '249', label: 'Sudan' },
  { countryCode: 'SR', value: '597', label: 'Suriname' },
  { countryCode: 'SJ', value: '47', label: 'Svalbard and Jan Mayen' },
  { countryCode: 'SZ', value: '268', label: 'Swaziland' },
  { countryCode: 'SE', value: '46', label: 'Sweden' },
  { countryCode: 'CH', value: '41', label: 'Switzerland' },
  { countryCode: 'SY', value: '963', label: 'Syria' },
  { countryCode: 'TW', value: '886', label: 'Taiwan' },
  { countryCode: 'TJ', value: '992', label: 'Tajikistan' },
  { countryCode: 'TZ', value: '255', label: 'Tanzania' },
  { countryCode: 'TH', value: '66', label: 'Thailand' },
  { countryCode: 'TG', value: '228', label: 'Togo' },
  { countryCode: 'TK', value: '690', label: 'Tokelau' },
  { countryCode: 'TO', value: '676', label: 'Tonga' },
  { countryCode: 'TT', value: '1', label: 'Trinidad and Tobago' },
  { countryCode: 'TN', value: '216', label: 'Tunisia' },
  { countryCode: 'TR', value: '90', label: 'Turkey' },
  { countryCode: 'TM', value: '993', label: 'Turkmenistan' },
  { countryCode: 'TC', value: '1', label: 'Turks and Caicos Islands' },
  { countryCode: 'TV', value: '688', label: 'Tuvalu' },
  { countryCode: 'UG', value: '256', label: 'Uganda' },
  { countryCode: 'UA', value: '380', label: 'Ukraine' },
  { countryCode: 'AE', value: '971', label: 'United Arab Emirates' },
  {
    countryCode: 'UM',
    value: '1',
    label: 'United States Minor Outlying Islands',
  },
  { countryCode: 'UY', value: '598', label: 'Uruguay' },
  { countryCode: 'UZ', value: '998', label: 'Uzbekistan' },
  { countryCode: 'VU', value: '678', label: 'Vanuatu' },
  { countryCode: 'VA', value: '379', label: 'Vatican City' },
  { countryCode: 'VE', value: '58', label: 'Venezuela' },
  { countryCode: 'VN', value: '84', label: 'Vietnam' },
  { countryCode: 'VG', value: '1', label: 'Virgin Islands - British' },
  { countryCode: 'VI', value: '1', label: 'Virgin Islands - US' },
  { countryCode: 'WF', value: '681', label: 'Wallis and Futuna' },
  { countryCode: 'EH', value: '212', label: 'Western Sahara' },
  { countryCode: 'YE', value: '967', label: 'Yemen' },
  { countryCode: 'ZM', value: '260', label: 'Zambia' },
  { countryCode: 'ZW', value: '263', label: 'Zimbabwe' },
]

export function getCountryByCode(code: string | undefined) {
  return data.find((country) => country.countryCode === code)
}

export function getCountryByValue(value: string) {
  return data.find((country) => country.value === value)
}
